<template>
  <div>
    <Modal v-model="openForm" :title="title" footer-hide fullscreen>

      <Tabs>
        <TabPane name="1" label="缩略图展示">
          <ul id="asaalarm">
            <li v-if="row.fileType == 1 || row.fileType == 2 || row.fileType == 0" v-for="row in tableData">
              <div class="asawrap">


                <img @click="scanimg(row)" v-if="row.fileType == 0" :src="row.filePath" />

                <video :src="row.filePath" @click="bofang(row)" type="md-play"
                  v-if="row.fileType == 1 || row.fileType == 2"></video>
              </div>

              <div class="asatext">
                <p>文件类型：{{ row.fileType1 }} <a target="_blank" :href="row.filePath">下载</a></p>
                <p>上传类型：{{ row.uploadTime1 }}</p>

              </div>
            </li>
          </ul>
        </TabPane>
        <TabPane name="2" label="列表展示">
          <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
            :height="utils.setTableHeight(140)">
            <template slot-scope="{ row, index }" slot="media">
              <viewer v-if="row.fileType == 0">
                <img :src="row.filePath" width="24" height="24" style="margin-right: 4px; cursor: pointer" />
              </viewer>
              <Button v-if="row.fileType == 1 || row.fileType == 2" @click="bofang(row)">播放</Button>
            </template>
            <template slot-scope="{ row, index }" slot="action">
              <a target="_blank" :href="row.filePath">下载</a>
            </template>
          </Table>
        </TabPane>

      </Tabs>
      <viewer v-show="false">
        <img :src="imgsrc" width="50" height="50" ref="img" />
      </viewer>
    </Modal>

    </Modal>
    <Modal v-model="openVideo" width="760" title="视频/音频" footer-hide @on-cancel="stop">
      <video id="video" width="728" controls></video>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openForm: false,
      openVideo: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "文件名",
          key: "fileName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "文件大小/B",
          key: "fileSize",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "文件类型",
          key: "fileType1",

          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "上传类型",
          key: "accStatus",
          render: (h, data) => {
            return h("div", this.$t("uploadType." + data.row.uploadType));
          },
          minWidth: 100,
          maxWidth: 200,
        },

        {
          title: "上传状态",
          key: "accStatus",
          render: (h, data) => {
            return h("div", this.$t("uploadState." + data.row.uploadState));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "上传时间",
          key: "uploadTime1",

          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "记录时间",
          key: "recordTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.recordTime));
          },
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "查看",
          slot: "media",
          width: 70,
          fixed: "right",
        },
        {
          title: "下载",
          slot: "action",
          width: 70,
          fixed: "right",
        },
      ],
      tableData: [],
      total: 0,
      searchItem: {
        id: 0,
        pageSize: 50,
        pageNumber: 1,
      },
      title: '',
      imgsrc: '/static/photo.jpg'
    };
  },
  methods: {
    open(v) {
      this.openForm = true;
      this.searchItem.id = v.id;
      this.getList();
      this.title = v.alarmTypeName;
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.alarm + "/alarmAsc/getFiles",
        //http://v.ly-gps.com/files/
        //https://cloud.ly-gps.com/files/alarm_files/16200134350_230505152650_0/00_65_6507_00_20230505152915459.jpg
        //http://v.ly-gps.com/files/16200134350_230505152650_0/00_65_6507_00_20230505152915459.jpg
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data;
          this.tableData = data;
          for (let i = 0; i < data.length; i++) {
            data[i].fileType1 = this.$t("fileType." + data[i].fileType);
            data[i].uploadTime1 = this.utils.time(data[i].uploadTime);
          }

        }
      });
    },
    exportAll() {
      var params = [
        {
          name: "deviceIdList",
          value: this.deviceIdList,
        },
        {
          name: "startTime",
          value: this.timeObj.start,
        },
        {
          name: "endTime",
          value: this.timeObj.end,
        },
      ];
      this.utils.exportData(axios.report + "/countDaily/export", params);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    bofang(v) {
      this.openVideo = true;
      var video = document.getElementById("video");
      video.src = v.filePath;
      video.play();

    },
    scanimg(v) {
      this.imgsrc = v.filePath;
      this.$refs.img.click();
    },
    stop() {
      var video = document.getElementById("video");
      video.pause();
    },
  },
};
</script>
<style>
#asaalarm {
  display: flex;
}

#asaalarm li {
  flex: 1;
  margin: 0 10px 30px 10px;
}

#asaalarm .asawrap {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #333;
}

#asaalarm .asawrap img,
#asaalarm .asawrap video {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

#asaalarm .asatext {
  line-height: 1.5;
}
#asaalarm .asatext p:first-child {
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/alarm/ascSelectFujian.vue